import { getMinutes } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import format from 'date-fns/format';
import getHours from 'date-fns/getHours';

interface DateFormattable {
  utc: () => {
    format: (format: string) => string;
  };
}

export const breakOptions = [
  {
    value: '00:00:00',
    label: 'No break',
  },
  {
    value: '00:30:00',
    label: '30 min',
  },
  {
    value: '01:00:00',
    label: '60 min',
  },
];

export const formatDate = (d: DateFormattable): string => d.utc().format('YYYY-MM-DD HH:mm:ssZ');

interface CurrencyFormatOptions {
  decimalScale?: number;
  decimalSeparator?: string;
  thousandSeparator?: string;
  rounded?: boolean;
}

export const formatCurrency = (value: number, options?: CurrencyFormatOptions): string => {
  if (typeof value !== 'number') return value;
  const formatCurrencyValue = (value: number, options?: CurrencyFormatOptions): string => {
    const { decimalSeparator = ',', thousandSeparator = ' ', rounded = false } = options ?? {};
    let formattedValue = value;
    if (rounded) {
      formattedValue = Math.round(value);
    }
    return formattedValue
      .toString()
      .toString()
      .replace('.', decimalSeparator)
      .replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
  };
  return formatCurrencyValue(value, options) + ',-';
};

export const disabledDateTime = () => {
  function range(start: number, end: number): number[] {
    const result: number[] = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }
  return {
    disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 7], // () => range(0, 24).splice(4, 20),
    disabledMinutes: () => range(0, 0),
    disabledSeconds: () => range(0, 0),
  };
};

export const stringToDateUTC = (dateString: string) => Number.parseInt(format(new Date(dateString), 'TT'));
export const forceTwoDigits = (n: number) => n.toString().padStart(2, '0');
interface TimeZoneFormatOptions {
  date: string | number | Date;
  fmt: string;
  tz: string;
}

export const formatInTimeZone = (
  date: TimeZoneFormatOptions['date'],
  fmt: TimeZoneFormatOptions['fmt'],
  tz: TimeZoneFormatOptions['tz'],
): string => format(utcToZonedTime(date, tz), fmt);

export const stringToDaysJsFormat = (date: string) =>
  date
    ? `${forceTwoDigits(getHours(new Date(date.replace(/Z/g, ''))))}:${forceTwoDigits(getMinutes(new Date(date.replace(/Z/g, ''))))}:00`
    : '';

export type OrdinaryHours = {
  hours?: number;
  minutes?: number;
};
